import { useSelector } from 'react-redux';

export default () => {
  const {
    id: currentOrgId,
    name: currentOrgName,
    save_type: saveType,
    roles = [],
    orgUsers = [],
    userId,
    user: { user_type: currentUserType } = {},
  } = useSelector(
    ({
      dashboard: {
        currentOrganization: { details = { user: {} } },
      },
      user: {
        currentUser: {
          details: {
            roles,
            organizations_users: orgUsers,
            id: userId,
          },
        },
      },
    }) => ({ ...details, roles, orgUsers, userId }),
  );
  return {
    currentOrgId,
    currentOrgName,
    saveType,
    currentUserType,
    userId,
    roles,
    orgUsers,
  };
};
